import { useState } from 'react'
import { Button } from 'flowbite-react'

interface ActionItem {
  title: string
  action: (data?: Record<string, any>) => Promise<void> | void
  icon?: React.ReactNode
}

interface ActionListProps {
  data: Record<string, any>
  actions?: ActionItem[]
}

const ActionList = ({ actions, data }: ActionListProps) => {
  const [loadingIdx, setLoadingIdx] = useState<number | null>(null)

  const handleOnClick = async (item: ActionItem, idx: number) => {
    try {
      setLoadingIdx(idx)
      await item.action(data)
    } finally {
      setLoadingIdx(null)
    }
  }

  return (
    <div className="flex justify-center items-center gap-5 h-full" data-testid="action-list">
      {actions?.map((item, idx) => (
        <span key={idx} className="flex items-center">
          <Button pill onClick={async () => handleOnClick(item, idx)} isProcessing={loadingIdx === idx} color="dark">
            <span className="flex items-center gap-2">
              {loadingIdx !== idx && (item.icon)}
              {item.title}
            </span>
          </Button>
        </span>
      ))}
    </div>
  )
}

export default ActionList